<h2 mat-dialog-title>Regel op 0 gezet</h2>
<mat-dialog-content>
  Let op!<br>
  Deze regel is op 0 gezet maar er zijn al 1 of meerdere kisten afgecheckt<br>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="close()">Ok</button>
</mat-dialog-actions>
